<template>
  <router-view module="call-center" />
</template>

<script>
export default {
  name: "DealCallCenter"
};
</script>

<style></style>
